import React, { useContext, useEffect, useState } from "react";
import {
    Categorie_pieces, Categorie_pieces_2,
    Dossier,
    GarantMonoBloc,
    GarantPhysique,
    Sections_dossier,
    Type_garantie,
} from "shared/types/types";
import { ordreCategorie, uuid } from "features/documents";
import DocList from "./DocList";
import Card from "./Card";
import { FolderContext } from "features/documents";
import { UserContext } from "features/account";
import { ReactComponent as IconDelete } from "../../assets/img/icons/icon_Trash.svg";
import Hug from "../Hug";
import Modal from "shared/ui/Modal";
import { toast } from "react-toastify";


const getDescriptionForCategory = (category: Categorie_pieces): string => {
    switch (category) {
        case Categorie_pieces.IDENTITE:
            return "Le propriétaire ou l'agence immobilière peut demander une pièce d'identité en cours de validité, toute qu'une carte d'identité, un passeport, un permis de conduire ou une carte de séjour/résident/UE-EEE.";
        case Categorie_pieces.DOMICILE:
            return "Le propriétaire peut exiger un justificatif de domicile : 3 quittances de loyer, attestation d'hébergement, élection de domicile ou taxe foncière/titre de propriété.";
        case Categorie_pieces.SITUATION_PRO:
            return "Le propriétaire peut demander un justificatif d'activité : contrat de travail, extrait kbis, immatriculation, certificat Insee, carte professionnelle, preuve d'activité, ou carte/certificat étudiant.";
        case Categorie_pieces.RESSOURCES:
            return "Le propriétaire peut exiger un justificatif de ressources : Avis d'imposition, fiches de paie, bilans ou attestation comptable, allocations/retraites/indemnités, taxe foncière ou titre de propriété, revenus fonciers ou financiers, aides au logement, indemnités de stage ou bourse.";
        default:
            return "";
    }
};

export default function GarantsPanel(){
    const [expandedGarant, setExpandedGarant] = useState<string | null>(null);
    const [choice, setChoice] = useState<Type_garantie>(Type_garantie.PHYSIQUE);

    const { user, isVerified } = useContext(UserContext);
    const { folder, tryAddGarantToFolder, tryRemoveGarant } = useContext(FolderContext);

    const [garants, setGarants] = useState<any[]>([]);
    const [garantId, setGarantId] = useState<string | null>(null);

    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);

    useEffect(() => {
        setGarants(folder?.garants || []);
    }, [folder?.garants, folder]);

    const handleDelete = async (id: string) => {
        setGarantId(id);
        setConfirmModalIsOpen(true);
    };

    return(
        <div style={{flex:1, padding:'1rem', display:'flex', flexDirection:'column', gap:'1rem'}}>
            <div style={{ background: 'white',borderRadius: '8px',boxShadow: '0 1px 3px rgba(0,0,0,0.1)',padding: '24px', marginBottom: '16px'}}>
                <h3 style={{fontSize: '18px', fontWeight: 600, color: '#1f2937', marginBottom: '16px'}}>GARANT(S)</h3>
                <p style={{fontSize:14, color:'#64748b', marginBottom:12}}>
                    Pour constituer votre dossier, vous pouvez présenter différents types de garants: un garant
                    physique (parent, proche, tiers), un garant institutionnel (Visale, etc) ou encore une garantie
                    bancaire (dépôt bloqué équivalent à plusieurs mois de loyers).
                </p>
                <div style={{display:'flex', flexDirection:'column', gap:'8px', marginBottom:'16px'}}>
                    {(Object.values(Type_garantie) as Type_garantie[]).map(t =>(
                        <label key={t} style={{display:'flex', alignItems:'center', gap:8, fontSize:14}}>
                            <input type="radio" checked={choice === t} onChange={()=>setChoice(t)}/> {t}
                        </label>
                    ))}
                </div>
                <button onClick={async () => {
                    setGarants([...garants, await tryAddGarantToFolder(folder?.id!, `${choice} ${garants.length + 1}`, choice, user?.type)]) }
                }

                        style={{backgroundColor: '#e0f2fe',color: '#1956A8',border: '1px solid #3b82f6',padding: '10px 20px',borderRadius: '5px',cursor: 'pointer',fontSize: '14px',fontWeight: 'bold',transition: 'background-color 0.3s ease, color 0.3s ease',outline: 'none',width: 'fit-content'}}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#1956A8';
                    e.currentTarget.style.color = 'white';
                }} onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#e0f2fe';
                    e.currentTarget.style.color = '#1956A8';
                }}>
                    AJOUTER UN GARANT + 
                </button>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
                {garants.map(garant => (
                    <div key={garant.id} style={{background: expandedGarant === garant.id ? 'white' : '#f8fafc',border: expandedGarant === garant.id ? '1px solid #3b82f6' : '1px solid #e2e8f0', borderRadius: '8px',overflow: 'hidden'}}>
                        <button
                            onClick={() => setExpandedGarant(expandedGarant === garant.id ? null : garant.id)} style={{width: '100%',padding: '20px',background: 'none',border: 'none',cursor: 'pointer',display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                            <div style={{fontWeight: 600,color: '#1e293b',fontSize: '16px'}}>
                                {garant.name}
                            </div>
                            <div className="hug__list__item error"
                                 onClick={()=> {
                                     handleDelete(garant.id)
                                 }}>
                                <IconDelete
                                  width={16}
                                  height={16}
                                  fill="#FF5326"
                                />{" "}

                            </div>
                            <div style={{transform: expandedGarant === garant.id ? 'rotate(180deg)' : 'rotate(0deg)',transition: 'transform 0.2s',color: '#6b7280'}}>
                                ▼
                            </div>
                        </button>

                        {expandedGarant === garant.id && (
                            <div style={{padding: '0 20px 20px',borderTop: '1px solid #e2e8f0'}}>
                                {garant.typeGarantie === Type_garantie.PHYSIQUE && (
                                    <div style={{ marginTop: 20 }}>
                                        {ordreCategorie.map(category => {
                                            const gp = garant as GarantPhysique;
                                            return (
                                                <Card key={category} title={category} right={<span style={{fontSize:12, color: '#64748b'}}>{getDescriptionForCategory(category)}</span>}>
                                                    <div style={{display: 'flex', alignItems: 'flex-start', gap:'1rem'}}>
                                                        <DocList
                                                          garantId={garant.id?.toString()}
                                                          categoriePieces={category}
                                                          sectionsDossier={Sections_dossier.GARANTS}
                                                          typeGarantie={Type_garantie.PHYSIQUE}
                                                        />
                                                    </div>
                                                </Card>
                                            );
                                        })}
                                    </div>
                                )}

                                {garant.typeGarantie === Type_garantie.INSTITUTIONNEL && (
                                    <div style={{ marginTop: 20 }}>
                                        <Card title="CERTIFICAT DE GARANTIE" right={<span style={{fontSize:12, color: '#64748b'}}>Certificat fourni par l'organisme de garantie institutionnel</span>}>
                                            <div style={{display:'flex', alignItems: 'flex-start', gap:'1rem'}}>
                                                <DocList
                                                  garantId={garant.id?.toString()}
                                                  categoriePieces={Categorie_pieces_2.CERTIFICAT_GARANTIE}
                                                  sectionsDossier={Sections_dossier.GARANTS}
                                                  typeGarantie={Type_garantie.INSTITUTIONNEL}
                                                />
                                            </div>
                                        </Card>
                                    </div>
                                )}

                                {garant.typeGarantie === Type_garantie.BANQUE && (
                                    <div style={{ marginTop: 20 }}>
                                        <Card title="GARANTIE BANCAIRE" right={<span style={{fontSize:12, color: '#64748b'}}>Attestation de dépôt de garantie ou caution bancaire</span>}>
                                            <div style={{display:'flex', alignItems: 'flex-start', gap:'1rem'}}>
                                                <DocList
                                                  garantId={garant.id?.toString()}
                                                  categoriePieces={Categorie_pieces_2.CERTIFICAT_GARANTIE}
                                                  sectionsDossier={Sections_dossier.GARANTS}
                                                  typeGarantie={Type_garantie.BANQUE}
                                                />
                                            </div>
                                        </Card>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {confirmModalIsOpen && (
              <Modal
                title="Supprimer un dossier"
                type="error"
                labelOnConfirm="Supprimer"
                isOpen={confirmModalIsOpen}
                onClose={(e) => {
                    e.stopPropagation();
                    setConfirmModalIsOpen(false);
                    setGarantId(null);
                }}
                onConfirm={async (e) => {
                    e.stopPropagation();
                    const response = await tryRemoveGarant(Number(folder?.id), Number(garantId));
                    if (response) {
                        toast.info("Votre garant a bien été supprimé", {
                            position: "top-center",
                        });
                    } else {
                        toast.error("Il y a eu un problème...", {
                            position: "top-center",
                        });
                    }
                    setGarantId(null);
                    setConfirmModalIsOpen(false);
                }}>
                  <p>Êtes vous sûr de vouloir supprimer ce garant ? La suppression est définitive.</p>
              </Modal>
            )}
        </div>
    );
}